import { connect } from 'react-redux';
import { getCurrentBranding } from '../../../redux/reducers/branding.reducer';
import LazyLoadCustom from '../LazyLoadCustom/LazyLoadCustom';
import {
  Logout,
  NotificationsNoneOutlined,
  Menu as MenuIcon,
  Close,
  East,
  HelpCenter,
  HelpCenterOutlined,
} from '@mui/icons-material';
import { Avatar, IconButton, Popover, Box, Typography, Divider, Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getUserProfile } from '../../../redux/reducers/userProfile.reducer';
import { useEffect, useState } from 'react';
import lamp from '../../../assets/images/lamp.svg';
import {
  apiValidation,
  get,
  getAvatarForUser,
  iosCaller,
  isIosApp,
  isWebView,
  post,
} from '../../../Utilities';
import {
  getClientId,
  getClientUserId,
  getLanguageObject,
  getRoleArray,
} from '../../../redux/reducers/clientUserId.reducer';
import InitialsAvatar from '../../Login/Preloader/InitialsAvatar';
import { Settings, User, FileText, Wallet } from 'lucide-react';

import Swal from 'sweetalert2';
import { clientUserIdActions } from '../../../redux/actions/clientUserId.action';
import { userProfileActions } from '../../../redux/actions/userProfile.action';
import { firstTimeLoginActions } from '../../../redux/actions/firsttimeLogin.action';
import { feeActions } from '../../../redux/actions/fees.actions';
import { Button } from 'react-bootstrap';
import { deleteFcmTokenWeb } from '../../../Utilities/firebase';

const languages = [
  { language_id: 1, language_name: 'English' },
  { language_id: 2, language_name: 'हिन्दी' },
  { language_id: 3, language_name: 'ગુજરાતી (Gujarati)' },
  // { language_id: 4, language_name: 'অসমীয়া (Assamese)' },
  { language_id: 5, language_name: 'বাংলা (Bengali)' },
  { language_id: 6, language_name: 'ಕನ್ನಡ (Kannada)' },
  { language_id: 7, language_name: 'മലയാളം (Malyalam)' },
  { language_id: 8, language_name: 'मराठी (Marathi)' },
  { language_id: 9, language_name: 'ਪੰਜਾਬੀ (Punjabi)' },
  { language_id: 10, language_name: 'தமிழ் (Tamil)' },
  { language_id: 11, language_name: 'తెలుగు (Telugu)' },
  { language_id: 12, language_name: 'ଓଡ଼ିଆ (Odia)' },
  { language_id: 1, language_name: '' },
  { language_id: 1, language_name: '' },
];

const useStyles = makeStyles((theme) => ({
  popover: {
    '& .MuiPopover-paper': {
      borderRadius: '16px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
      border: '1px solid #e5e7eb',
      minWidth: '280px',
      padding: 0,
      overflow: 'visible',
    },
  },
  profileHeader: {
    padding: '24px 24px 16px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    color: '#2b2d42',
    position: 'relative',
  },
  profileAvatar: {
    width: '64px !important',
    height: '64px !important',
    marginBottom: '12px',
    border: '3px solid rgba(255, 255, 255, 0.2)',
    fontSize: '24px',
    fontWeight: 600,
  },
  profileName: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '0px',
    color: '#2b2d42',
  },
  profileEmail: {
    fontSize: '14px',
    opacity: 0.9,
    color: '#2b2d42',
  },
  manageProfileButton: {
    borderRadius: '8px',
    color: 'white',
    width: '100%',
  },
  manageProfileButtonContainer: {
    margin: '2px 24px',
  },
  menuSection: {
    padding: '8px 0',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 24px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '14px',
    fontWeight: 500,
    color: '#374151',
    '&:hover': {
      backgroundColor: '#f9fafb',
      color: '#1f2937',
    },
  },
  menuItemIcon: {
    marginRight: '12px',
    width: '18px',
    height: '18px',
    color: '#6b7280',
  },
  signOutItem: {
    color: '#dc2626 !important',
    borderTop: '1px solid #e5e7eb',
    marginTop: '8px',
    paddingTop: '16px',
    '&:hover': {
      backgroundColor: '#fef2f2 !important',
      color: '#dc2626 !important',
    },
  },
  divider: {
    margin: '0 24px',
    backgroundColor: '#e5e7eb',
  },
  drawer: {
    '& .MuiDrawer-paper': {
      width: '280px',
      backgroundColor: 'white',
    },
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    borderBottom: '1px solid #e5e7eb',
  },
  drawerNavItem: {
    padding: '16px 24px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: 500,
    color: '#374151',
    transition: 'all 0.2s ease',
    borderBottom: '1px solid #f3f4f6',
    '&:hover': {
      backgroundColor: '#f9fafb',
      color: '#1f2937',
    },
  },
  drawerLoginButton: {
    margin: '20px 24px',
  },
}));

function moveLastTwoToFront(str) {
  if (str.length <= 2) return str;
  return str.slice(-2) + ' ' + str.slice(0, -2);
}

const PageHeaderNew = (props) => {
  const classes = useStyles();
  const {
    branding,
    history,
    darker,
    userProfile,
    isClientColor,
    clientUserId,
    roleArray,
    clearClientIdDetails,
    clearProfile,
    setFeeCustomPlanArrayToStore,
    setAppLanguageToStore,
    setAppLanguageObjectToStore,
    setFirstTimeLoginToStore,
    clientId,
    // isLogout,
    showCourses,
    scrollToAbout,
    scrollToCourses,
    scrollToFooter,
    scrollToTop,
    noNav,
    backgroundColor,
    languageObject = {},
    getPermissions = () => {},
  } = props;

  const [greeting, setTime] = useState('');
  const [badgeValue, setBadgeValue] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openLanguages, setOpenLanguages] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [isFaqAdded, setIsFaqAdded] = useState(false);

  useEffect(() => {
    get({ client_id: clientId }, '/areFaqsAdded').then((res) => {
      if (res && res.success) {
        setIsFaqAdded(res.result);
      }
    });
  }, []);
  
  const isLogout = !Boolean(userProfile.token);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const changeAppLanguage = (languageId = 1) => {
    get({ language_id: languageId }, '/getActivityText').then((res) => {
      if (res && res.success) {
        if (Object.keys(res.result).length > 0) {
          setAppLanguageObjectToStore(res.result);
          setAppLanguageToStore(languageId);
        }
      }
      setOpenLanguages(false);
    });
  };

  const goToProfile = () => {
    const { push } = history;
    handleClose();
    if (clientId == 1104 || clientId == 2002) {
      if (history.location.pathname !== '/mulyankan-profile') {
        push({ pathname: '/mulyankan-profile' });
      }
      return;
    }
    if (history.location.pathname !== '/profile') {
      push({ pathname: '/profile' });
    }
  };

  const goToNotifications = () => {
    const { push } = history;
    push('/notifications');
  };

  useEffect(() => {
    get({ client_id: clientId, client_user_id: clientUserId }, '/getAllUserPermissionsLatest').then(
      (res) => {
        if (res && res.success) {
          setPermissions(res.result);
          getPermissions(res.result);
        }
      },
    );
  }, []);

  const partsOfDay = () => {
    const hours = new Date().getHours();
    if (hours >= 0 && hours < 12) setTime('Good Morning 🌤');
    else if (hours >= 12 && hours <= 17) setTime('Good Afternoon ☀️');
    else if (hours >= 17 && hours < 21) setTime('Good Evening 🌜');
    else if (hours >= 21 && hours < 24) setTime('Good Evening 🌜');
  };

  useEffect(() => {
    partsOfDay();
    get({ client_user_id: clientUserId, client_id: clientId }, '/ckeckNewNotifications').then(
      (res) => {
        if (res && res.success) {
          setBadgeValue(res.result);
        }
      },
    );
  }, []);

  const logout = () => {
    const logoutPayload = {
      client_user_id: clientUserId,
      client_id: clientId,
      device_type: isWebView ? 'android' : isIosApp ? 'ios' : 'web',
    };
    if (isWebView && typeof window.Android.removeClientUserId !== 'undefined') {
      window.Android.removeClientUserId();
      if (typeof window.Android.deleteFCMToken !== 'undefined') {
        window.Android.deleteFCMToken();
      }
    } else if (isIosApp) {
      iosCaller('removeClientUserId');
      iosCaller('deleteFCMToken');
    } else {
      deleteFcmTokenWeb();
    }
    if (isWebView && typeof window.Android.unsubscribeForNotification !== 'undefined') {
      window.Android.unsubscribeForNotification();
    } else if (isIosApp) {
      // iosCaller('unsubscribeForNotification');
    }
    post(logoutPayload, '/logoutUser')
      .then((res) => {
        const result = apiValidation(res);
        if (result) {
          clearProfile();
          sessionStorage.clear();
          clearClientIdDetails();
          setFeeCustomPlanArrayToStore([]);
          setFirstTimeLoginToStore(false);
          history.push({ pathname: '/preload' });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: 'Oops!',
          text: `Unable to logout :(`,
          timer: 3000,
        });
      });
  };

  const handleMenuItemClick = (action) => {
    handleClose();
    action();
  };

  return (
    <div
      style={
        isLogout
          ? { boxShadow: '0px 2px 4px -2px rgba(0, 0, 0, 0.15)' }
          : backgroundColor
          ? { backgroundColor }
          : {}
      }
      className={`PageHeader__headerNew ${
        darker
          ? 'var(--lighter-blue)'
          : isClientColor
          ? 'var(--superlight-blue)'
          : isLogout
          ? 'loggedOutBackground'
          : 'loggedInBackground'
      }`}
    >
      {isLogout && !noNav && (
        <>
          {/* Desktop Navigation - Hidden on small screens */}
          <div
            className='d-none d-lg-flex gap-3 align-items-center justify-content-center position-absolute '
            style={{ height: '76px', top: '0px', left: '50%', transform: 'translateX(-50%)' }}
          >
            <div role='button' onClick={scrollToTop} className='font mb-0 PageHeader__activeNav'>
              Home
            </div>
            <div onClick={scrollToAbout} role='button' className='font mb-0 PageHeader__activeNav'>
              About
            </div>
            {showCourses && (
              <div
                role='button'
                onClick={scrollToCourses}
                className='font mb-0 PageHeader__activeNav'
              >
                Courses
              </div>
            )}
            <div role='button' onClick={scrollToFooter} className='font mb-0 PageHeader__activeNav'>
              Contact
            </div>
            {isFaqAdded && (
              <div
                role='button'
                onClick={() => history.push('/faq')}
                className='font mb-0 PageHeader__activeNav'
              >
                FAQs
              </div>
            )}
          </div>

          {/* Mobile Hamburger Menu Button - Visible only on small screens */}
          <div
            className='d-flex d-lg-none position-absolute'
            style={{ right: '18px', top: '14px', zIndex: 10 }}
          >
            <IconButton
              onClick={toggleMobileMenu}
              style={{ color: isClientColor ? 'white' : '#374151' }}
            >
              <MenuIcon />
            </IconButton>
          </div>

          {/* Mobile Drawer */}
          <Drawer
            anchor='right'
            open={mobileMenuOpen}
            onClose={closeMobileMenu}
            className={classes.drawer}
          >
            <div>
              <div className={classes.drawerHeader}>
                <Typography
                  onClick={() => {
                    if (clientId == 25 && isWebView) {
                      window.Android.showToast('Live Starting');
                    }
                  }}
                  variant='h6'
                  style={{ fontWeight: 600, color: '#2b2d42' }}
                >
                  Menu
                </Typography>
                <IconButton onClick={closeMobileMenu} size='small'>
                  <Close />
                </IconButton>
              </div>

              <div>
                <div
                  className={classes.drawerNavItem}
                  onClick={() => {
                    scrollToTop();
                    closeMobileMenu();
                  }}
                >
                  Home
                </div>
                <div
                  className={classes.drawerNavItem}
                  onClick={() => {
                    scrollToAbout();
                    closeMobileMenu();
                  }}
                >
                  About
                </div>
                {showCourses && (
                  <div
                    className={classes.drawerNavItem}
                    onClick={() => {
                      scrollToCourses();
                      closeMobileMenu();
                    }}
                  >
                    Courses
                  </div>
                )}
                <div
                  className={classes.drawerNavItem}
                  onClick={() => {
                    scrollToFooter();
                    closeMobileMenu();
                  }}
                >
                  Contact
                </div>
              </div>

              <div className={classes.drawerLoginButton}>
                <Button
                  onClick={() => {
                    closeMobileMenu();
                    if (clientId !== 1104) {
                      history.push('/login');
                    }
                  }}
                  className='font-bold w-100  mb-3'
                  style={{ fontSize: '14px' }}
                  variant='customSecondary'
                >
                  Login
                </Button>
                <Button
                  onClick={() => {
                    closeMobileMenu();
                    if (clientId !== 1104) {
                      history.push('/login');
                    }
                  }}
                  className='font-bold w-100 px-3'
                  style={{ fontSize: '14px' }}
                  variant='customPrimary'
                >
                  Sign Up
                </Button>
              </div>
            </div>
          </Drawer>
        </>
      )}

      <div
        style={
          !isLogout
            ? {
                background: backgroundColor ? backgroundColor : '',
              }
            : {}
        }
        // style={!isLogout ? { background: backgroundColor } : {}}
        className='pr-3 pl-2 py-1 d-flex align-items-center PageHeader__headerNewContainer justify-content-between'
      >
        <div onClick={() => history.push('/')} className='d-flex align-items-center'>
          <LazyLoadCustom
            className='PageHeader__clientLogo'
            src={branding?.branding?.client_logo}
          />
          {!isLogout && (
            <p className='mb-0 ml-3 PageHeader__greeting'>
              {clientId == 1104 && window.location.pathname === '/'
                ? languageObject.hello || 'Namaste'
                : clientId !== 1104
                ? greeting
                : ''}
            </p>
          )}
          {branding?.branding?.client_name?.length <= 30 && !isLogout ? (
            <p className='mb-0 ml-3 PageHeader__clientName'>{branding?.branding?.client_name}</p>
          ) : branding?.branding?.client_name?.length > 30 && !isLogout && screen.width > 767 ? (
            <p className='mb-0 ml-3 PageHeader__clientName'>{branding?.branding?.client_name}</p>
          ) : null}

          {/* {branding?.branding?.client_name?.length <= 30 && isLogout && (
            <p className='mb-0 ml-3 PageHeader__clientNameLogout'>
              {branding?.branding?.client_name}
            </p>
          )} */}
        </div>
        {!isLogout ? (
          <div className='d-flex align-items-center position-relative'>
            <p className='PageHeader__nameGreetingText font'>
              {moveLastTwoToFront(greeting).trim()}, {userProfile?.firstName}
            </p>
            {clientId != 137 && clientId != 1104 && (
              <IconButton onClick={goToNotifications} className='mx-1 position-relative'>
                <NotificationsNoneOutlined />
                {badgeValue ? <div className='PageHeader__notiiconBadge'>{badgeValue}</div> : null}
              </IconButton>
            )}
            
            {!userProfile.profile_image ? (
              <InitialsAvatar
                onClick={clientId == 137 ? goToProfile : handleClick}
                role='button'
                name={`${userProfile.firstName} ${userProfile.lastName}`}
                color={getAvatarForUser(clientUserId)}
                size='sm'
              />
            ) : (
              <Avatar
                onClick={clientId == 137 ? goToProfile : handleClick}
                style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                alt={`${userProfile.first_name} ${userProfile.last_name}`}
                src={userProfile.profile_image}
                sx={{ bgcolor: 'red' }}
              />
            )}
          </div>
        ) : (
          <div className='d-none gap-2 d-none d-lg-flex'>
            <Button
              onClick={() => {
                history.push('/login');
              }}
              className='font-bold  py-2 mx-2'
              style={{ background: 'transparent', fontSize: '14px' }}
              variant='boldText'
            >
              Login
            </Button>
            <Button
              onClick={() => {
                history.push('/login');
              }}
              className='font-bold PageHeader__loginButton '
              style={{ fontSize: '14px', padding: '8px 30px' }}
              variant='customPrimary'
            >
              Sign Up
            </Button>
          </div>
        )}
      </div>

      <Popover
        className={classes.popover}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box>
          {/* Profile Header Section */}
          <div className={classes.profileHeader}>
            {!userProfile.profile_image ? (
              <InitialsAvatar
                name={`${userProfile.firstName} ${userProfile.lastName}`}
                color={getAvatarForUser(clientUserId)}
                role='button'
                size='md'
              />
            ) : (
              <Avatar
                className={classes.profileAvatar}
                alt={`${userProfile.first_name} ${userProfile.last_name}`}
                src={userProfile.profile_image}
              />
            )}
            <div>
              <Typography className={`font-bold ${classes.profileName} clampOn1Line`}>
                {userProfile.firstName?.trim()} {userProfile.lastName?.trim()}
              </Typography>
              {userProfile.contact && (
                <Typography className={`text-muted ${classes.profileEmail}`}>
                  +{userProfile.countryCode || '91'} {userProfile.contact}
                </Typography>
              )}
            </div>
          </div>

          <div className={classes.manageProfileButtonContainer}>
            <Button
              fullWidth
              variant='customPrimary'
              className={classes.manageProfileButton}
              onClick={() => handleMenuItemClick(goToProfile)}
            >
              {languageObject.manage_your_profile || 'Manage your profile'}
            </Button>
          </div>

          {/* Menu Items */}
          <div className={classes.menuSection}>
            {roleArray.includes(4) || roleArray.includes(5) ? (
              Boolean(permissions.invoices) && (
                <div
                  className={classes.menuItem}
                  onClick={() =>
                    handleMenuItemClick(() => {
                      history.push('/invoices-list');
                    })
                  }
                >
                  <FileText className={classes.menuItemIcon} />
                  Invoices
                </div>
              )
            ) : roleArray.includes(1) && clientId !== 1104 ? (
              <div
                className={classes.menuItem}
                onClick={() =>
                  handleMenuItemClick(() => {
                    history.push('/student-invoices');
                  })
                }
              >
                <FileText className={classes.menuItemIcon} />
                Invoices
              </div>
            ) : null}

            {roleArray.includes(1) && isFaqAdded ? (
              <div
                className={classes.menuItem}
                onClick={() =>
                  handleMenuItemClick(() => {
                    history.push('/faq');
                  })
                }
              >
                <HelpCenterOutlined className={classes.menuItemIcon} />
                FAQs
              </div>
            ) : null}

            {(roleArray.includes(4) || roleArray.includes(5)) &&
              Boolean(permissions.settlements) && (
                <div
                  className={classes.menuItem}
                  onClick={() =>
                    handleMenuItemClick(() => {
                      history.push('/settlements');
                    })
                  }
                >
                  <Wallet className={classes.menuItemIcon} />
                  Settlements
                </div>
              )}

            {(roleArray.includes(4) || roleArray.includes(5)) && Boolean(permissions.settings) && (
              <div
                className={classes.menuItem}
                onClick={() =>
                  handleMenuItemClick(() => {
                    history.push('/app-settings');
                  })
                }
              >
                <Settings className={classes.menuItemIcon} />
                Settings
              </div>
            )}

            {clientId !== 1104 && (
              <div
                className={`${classes.menuItem} ${classes.signOutItem}`}
                onClick={() => handleMenuItemClick(logout)}
              >
                <Logout className={classes.menuItemIcon} />
                {languageObject.sign_out || 'Sign Out'}
              </div>
            )}
          </div>
        </Box>
      </Popover>
      <Drawer open={openLanguages} anchor='bottom' onClose={() => setOpenLanguages(false)}>
        <div>
          {languages.map((language) => (
            <div
              role='button'
              key={language}
              onClick={() => {
                changeAppLanguage(language.language_id);
              }}
              style={{
                padding: '16px',
                borderBottom: '1px solid #e5e7eb',
                fontFamily: 'Montserrat-Regular',
              }}
            >
              {language.language_name}
            </div>
          ))}
        </div>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  branding: getCurrentBranding(state),
  clientId: getClientId(state),
  userProfile: getUserProfile(state),
  clientUserId: getClientUserId(state),
  roleArray: getRoleArray(state),
  languageObject: getLanguageObject(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    clearClientIdDetails: () => {
      dispatch(clientUserIdActions.clearClientIdDetails());
    },
    clearProfile: () => {
      dispatch(userProfileActions.clearUserProfile());
    },
    setFirstTimeLoginToStore: () => {
      dispatch(firstTimeLoginActions.setFirstTimeLoginToStore());
    },
    setFeeCustomPlanArrayToStore: () => {
      dispatch(feeActions.setFeeCustomPlanArrayToStore());
    },
    setAppLanguageObjectToStore: (payload) => {
      dispatch(clientUserIdActions.setAppLanguageObjectToStore(payload));
    },
    setAppLanguageToStore: (payload) => {
      dispatch(clientUserIdActions.setAppLanguageToStore(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageHeaderNew);
